import { render, staticRenderFns } from "./comp_ProductDiscount.vue?vue&type=template&id=ed3d28b4&"
import script from "./comp_ProductDiscount.vue?vue&type=script&lang=js&"
export * from "./comp_ProductDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports